import type { ActionsObservable } from 'redux-observable';
import type { AjaxError } from 'rxjs';
import type { Epic } from 'epics/rxjs';
import { Observable, concat } from 'epics/rxjs';
import { sendEvent } from 'util/analytics';
import type {
    UpdateLoginAnnouncementsModel,
    UpdateLoginAnnouncementsSuccess,
    UpdateLoginAnnouncementsFailure,
    ResetLoginAnnouncementsSettings,
} from 'state/actions/login-announcements';
import {
    UPDATE_LOGIN_ANNOUNCEMENTS_MODEL,
    updateLoginAnnouncementsSuccess,
    updateLoginAnnouncementsFailure,
    resetLoginAnnouncements,
} from 'state/actions/login-announcements';

import type { HandleAjaxError } from 'state/actions/flags';
import { handleAjaxError } from 'state/actions/flags';

import type { LoginAnnouncementsUpdateResponse } from 'rest/login-announcements';
import { updateLoginAnnouncements } from 'rest/login-announcements';
import { isNetworkOrClientErrorCode } from 'util/error-codes';

export const updateLoginAnnouncementsEpic: Epic<
    | UpdateLoginAnnouncementsModel
    | UpdateLoginAnnouncementsSuccess
    | UpdateLoginAnnouncementsFailure
    | HandleAjaxError
    | ResetLoginAnnouncementsSettings
> = (action$: ActionsObservable<UpdateLoginAnnouncementsModel>) => {
    return action$.ofType(UPDATE_LOGIN_ANNOUNCEMENTS_MODEL).mergeMap((action: UpdateLoginAnnouncementsModel) => {
        const { meta } = action;
        return updateLoginAnnouncements(action.payload)
            .flatMap((response: LoginAnnouncementsUpdateResponse) => {
                if (meta?.analyticsSuccessEvent) {
                    sendEvent(meta.analyticsSuccessEvent);
                }
                return concat(
                    Observable.of(updateLoginAnnouncementsSuccess(response)),
                    Observable.of(resetLoginAnnouncements())
                );
            })
            .catch((error: AjaxError) => {
                if (meta?.analyticsFailureEvent && !isNetworkOrClientErrorCode(error.status)) {
                    sendEvent(meta.analyticsFailureEvent);
                }
                return concat(
                    Observable.of(updateLoginAnnouncementsFailure(error)),
                    Observable.of(handleAjaxError(error))
                );
            });
    });
};
